import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { Button, PageHeader } from 'mailup-web-components'
import { pageState } from 'Pages/TasksList/recoil/state/page'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()

  const [redirectUrl] = useRedirectorUrl()

  const { canCreateTrigger, isEmptyState } = useRecoilValue(pageState)

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Automation' }),
      'data-mu-test': 'breadcrumb-item__automation',
      className: 'test-breadcrumb-item__automation'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.AutomationTasks' }),
      'data-mu-test': 'breadcrumb-item__automation-tasks',
      className: 'test-breadcrumb-item__automation-tasks'
    }
  ]

  const ControlsComponent = () => {
    const handleSaveClick = () => {
      history.push('/automation/task')
    }

    return (
      <Button
        kind='primary'
        size='lg'
        className='test-buttonSave'
        data-mu-test='new-task'
        onClick={handleSaveClick}
      >
        {intl.formatMessage({ id: 'Load.TriggersList.NewTriggerButton' })}
      </Button>
    )
  }

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['Tasks', redirectUrl])
  }, [redirectUrl])

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      title={intl.formatMessage({ id: 'Load.NavMenu.AutomationTasks' })}
      ControlsComponent={
        canCreateTrigger && !isEmptyState ? ControlsComponent : false
      }
    />
  )
}

export default Header
